module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\">\n    <path d=\"M20.1 23.5c.3-5.4 2.4-10.3 5.1-14.9.4-.7 4.2-1.2 4.6-.6.4.5 0 .9-.2 1.4-.8 1.8-1.6 3.7-2.4 5.5-1.2 2.6-1.1 5.1.5 7.6 1 1.6 1.8 3.4 1.1 5.4-.6 1.8-1.7 3-3.7 3.1-1.9.1-3.1-.7-4-2.4-.8-1.7-1-3.4-1-5.1zM5.1 23.5c.3-5.5 2.5-10.3 5.1-14.9.4-.7 4.2-1.2 4.6-.6.4.5 0 .9-.2 1.4-.8 1.8-1.6 3.7-2.4 5.5-1.2 2.6-1.1 5.1.5 7.6 1 1.6 1.8 3.4 1.1 5.4-.6 1.8-1.7 3-3.7 3.1-1.9.1-3.1-.7-4-2.4-.8-1.7-1-3.4-1-5.1z\"/>\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/quote.svg
// module id = 387
// module chunks = 0